import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUserProfilePersonal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.46429 9.53571C8.46429 7.58299 10.0473 6 12 6C13.9527 6 15.5357 7.58299 15.5357 9.53571C15.5357 11.4884 13.9527 13.0714 12 13.0714C10.0473 13.0714 8.46429 11.4884 8.46429 9.53571ZM12 7.5C10.8757 7.5 9.96429 8.41142 9.96429 9.53571C9.96429 10.66 10.8757 11.5714 12 11.5714C13.1243 11.5714 14.0357 10.66 14.0357 9.53571C14.0357 8.41142 13.1243 7.5 12 7.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 14.1388 19.4361 16.0874 18.1012 17.5532C16.9239 15.3945 14.6339 13.9286 12 13.9286C9.36612 13.9286 7.07608 15.3945 5.89876 17.5532C4.56385 16.0874 3.75 14.1388 3.75 12ZM7.05025 18.6008C8.42904 19.6364 10.1429 20.25 12 20.25C13.8571 20.25 15.571 19.6364 16.9498 18.6008C16.0881 16.7276 14.1949 15.4286 12 15.4286C9.80507 15.4286 7.91188 16.7276 7.05025 18.6008Z",
		fill: "currentColor"
	})]
});
export { SvgIconUserProfilePersonal as ReactComponent };
